import React, {useState, useEffect} from 'react';
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import configVars from "../../config";
import { getWithExpiry, setWithExpiry } from '../../common';
import { getUserData } from "../../redux/actions/userdata";
import { useTranslation } from "react-i18next";

const ProfileOptions = () => {

    const [cookies] = useCookies(["sustainyou_user_jwt"]);
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(false);
    const [errorMsg, setErrorMsg] = useState('');
    const [hasCommunity, setHasCommunity] = useState(false);
    const [deleteCommunity, setDeleteCommunity] = useState(false);

    const [translation] = useTranslation("translations");

    const communityOn = useSelector(
        (state) => state?.userdata.allUserData?.user_meta?.community_on
    );

    const userCapabilities = useSelector(
        (state) => state?.userdata.allUserData?.all_capabilities
    );

    const dispatch = useDispatch();

    useEffect(() => {

        const userHasCommunity = getWithExpiry( 'has_community' );

        if ( userHasCommunity === 'yes' ) {
            setHasCommunity(true);
        } else if ( userHasCommunity === 'no' ) {
            setHasCommunity(false);
        }

        if ( ! userHasCommunity ) {

            if ( !communityOn ) {
                setHasCommunity(false);
            } else if ( communityOn === 'yes' ) {
                setHasCommunity(true);
            } else if ( communityOn === 'no' ) {
                setHasCommunity(false);
            }

        }

    }, [communityOn]);

    const getAllUserData = async (token) => {
		setLoading(true);
		await dispatch(getUserData(token));
		setLoading(false)
	}

    const handleJoinCommunity = async () => {

        if ( ! cookies.sustainyou_user_jwt )  return;

        setLoading(true);
        setError(false);
        setSuccess(false);
        setErrorMsg('');

        let userRequestData = new FormData();
        userRequestData.append( 'token', cookies.sustainyou_user_jwt );

        const fetchUrl = `${configVars.apiUrl}sustainchange/v1/handlecommunityaccess/`;

        try{

            const response = await fetch(
                fetchUrl,
                {
                method: "POST",
                headers: {
                    Authorization: `Basic ${configVars.auth}`,
                },
                body: userRequestData
                }
            );
            
            const updateResponse = await response.json();
    
            if ( updateResponse ) {

                if ( updateResponse.success === true ) {

                    setSuccess(true);
                    setWithExpiry( 'has_community', 'yes' );
                    setHasCommunity(true);
                    //localStorage.removeItem("user_data_expire");

                    getAllUserData( cookies.sustainyou_user_jwt );

                } else {

                    if ( updateResponse.data.already_member ) {
                        setWithExpiry( 'has_community', 'yes' );
                        setHasCommunity(true);

                        getAllUserData( cookies.sustainyou_user_jwt );
                    }

                    setError(true);
                    setErrorMsg( updateResponse.message );

                }
                

                //console.log( updateResponse );

            }

        } catch( error ) {
            console.log( error );
            return error;
        }

        setLoading( false );

    }

    const handleLeaveCommunity = async () => {

        if ( ! cookies.sustainyou_user_jwt )  return;

        setLoading(true);
        setError(false);
        setSuccess(false);
        setErrorMsg('');

        let userRequestData = new FormData();
        userRequestData.append( 'token', cookies.sustainyou_user_jwt );

        const fetchUrl = `${configVars.apiUrl}sustainchange/v1/deletecommunityaccount/`;

        try{

            const response = await fetch(
                fetchUrl,
                {
                method: "POST",
                headers: {
                    Authorization: `Basic ${configVars.auth}`,
                },
                body: userRequestData
                }
            );
            
            const updateResponse = await response.json();
    
            if ( updateResponse ) {

                if ( updateResponse.success === true ) {

                    setWithExpiry( 'has_community', 'no' );
                    setHasCommunity(false);
                    setDeleteCommunity(false);

                    getAllUserData( cookies.sustainyou_user_jwt );

                } else {

                    if ( updateResponse.data.need_password ) {
                        setError(true);
                        setErrorMsg(translation("login_to_community"));
                        setDeleteCommunity(false);
                    }

                }

                //console.log( updateResponse );

            }

        } catch( error ) {
            console.log( error );
            return error;
        }

        setLoading( false );


    }

    return (
        <div className="membership-wrap">
            <div className="mx-auto" style={{maxWidth: '800px'}}>

                {userCapabilities && userCapabilities.includes('community') && (
                    <div className="row">
                    <div className="col-12 col-lg-4 d-flex flex-column">
                        <span className="fw-bold">{translation("community_text")}</span>
                        <span className="opacity-half font-size-medium d-inline-block w-100 position-relative" style={{top: '-3px'}}>{translation("manage_community")}</span>
                    </div>
                    <div className="col-12 col-lg-8">

                        {error &&
                            <div className="my-3 w-100">
                                <div className="alert alert-secondary" role="alert">
                                   {errorMsg}
                                </div>
                            </div>
                        }

                        {success &&
                            <div className="my-3 w-100">
                                <div className="alert alert-sy-green" role="alert">
                                {translation("community_success")}
                                </div>
                            </div>
                        }

                        { hasCommunity &&
                            <div className="community-setting">
                                
                                { deleteCommunity &&
                                    <div className="toast fade show" role="alert" aria-live="assertive" aria-atomic="true">
                                        <div className="toast-header">
                                            <strong className="me-auto">{translation("leave_comm_warn")}</strong>
                                            <button type="button" className="btn-close" aria-label="Close" onClick={() => setDeleteCommunity(false)}></button>
                                        </div>
                                        <div className="toast-body">
                                            {translation("leave_comm_warn_desc")}
                                            <div className="mt-2 pt-2 d-flex justify-content-end">

                                                <button type="button" className="btn btn-secondary btn-sm text-white" onClick={() => handleLeaveCommunity()}>
                                                    <span className="me-2"> {translation("proceed_text")}</span>
                                                    {loading &&
                                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                                            <span className="visually-hidden">Loading...</span>
                                                        </div>
                                                    }
                                                    {!loading &&
                                                        <span><i className="fa fa-hand-o-right" aria-hidden="true"></i></span>
                                                    }
                                                </button>
                                            </div>
                                        </div>
                                    </div>
                                }

                                { !deleteCommunity &&
                                    <>
                                        <span className='d-inline-block w-100 mb-2'>{translation("comm_exists")}</span>
                                        <button type="button" className='btn btn-secondary btn-sm' onClick={() => setDeleteCommunity(true)}>
                                            <span className="pe-2">{translation("delete_comm")}</span>
                                            <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                        </button>
                                    </>
                                }
                            </div>
                        }

                        { ! hasCommunity &&
                            <div className="community-setting">
                                <button type="button" className="btn btn-primary btn-sm px-4 text-white" onClick={() => handleJoinCommunity()}>
                                    <span className="pe-2">{translation("join_comm")}</span>
                                    
                                    {loading &&
                                        <div className="spinner-border spinner-border-sm text-light" role="status">
                                            <span className="visually-hidden">Loading...</span>
                                        </div>
                                    }

                                    {!loading &&
                                        <i className="fa fa-long-arrow-right" aria-hidden="true"></i>
                                    }
                                </button>
                            </div>
                        }

                    </div>
                </div>
                )}
                
                
            </div>
        </div>
    )

}

export default ProfileOptions;